import { h } from '@stencil/core';

import en from '../../locale/en.json';
import { isDefined } from '../helper';
import {
    localeMap,
    templateMatcher,
} from './locHelper';

export function tComponent(key: string, locale: string, params?: any) {

    locale = locale?.toLowerCase();
    const value = localeMap[locale]?.[key] || en[key] || key;
    return interpolateComponent(value, params);
}

function interpolateComponent(expr: string, params?: any) {
    if (!params) {
        return expr;
    }

    const splitted = expr.split(templateMatcher);
    return <span class="trial-description-content">{splitted.map((substr) => isDefined(params[substr]) ? params[substr] : substr)}</span>;
}
